<template>
	<div>
		<br />
		<div v-for="(rp, id) in data.representates" class="col-lg-12">
			<div class="well well-sm">
				<div class="row">
					<div class="col-md-5 col-sm-6">
						<span>Nome</span>
						<input
							:disabled="disabled"
							v-model="rp.nome"
							type="text"
							class="form-control"
						/>
					</div>
					<div class="col-md-3 col-sm-6">
						<span>Qual</span>
						<input
							:disabled="disabled"
							v-model="rp.qual"
							type="text"
							class="form-control"
						/>
					</div>
					<div class="col-md-3 col-sm-6">
						<span>CPF</span>
						<div class="input-group">
							<input
								:disabled="disabled"
								v-model="rp.cpf"
								type="text"
								v-mask="'###.###.###-##'"
								placeholder="___.___.___-__"
								class="form-control"
							/>
							<div class="input-group-btn">
								<button
									:disabled="disabled"
									class="btn btn-danger"
									@click="$emit('remove', id)"
								>
									<i class="fa fa-trash"></i>
								</button>
							</div>
						</div>
					</div>
					<div class="col-md-1 col-sm-6">
						<br />
						<button
							class="btn btn-info btn-block"
							@click="rp.opened = !rp.opened"
						>
							<i v-if="!rp.opened" class="fa fa-angle-down"></i>
							<i v-else class="fa fa-angle-up"></i>
						</button>
					</div>
				</div>

				<div class="row" :class="{ 'close-item': !rp.opened }">
					<br />
					<div class="col-md-3 col-sm-6">
						<span>R.G.</span>
						<input
							:disabled="disabled"
							v-model="rp.rg"
							type="text"
							class="form-control"
						/>
					</div>
					<div class="col-md-6 col-sm-6">
						<span>Email</span>
						<input
							:disabled="disabled"
							v-model="rp.email"
							type="text"
							class="form-control"
						/>
					</div>

					<div class="col-md-3 col-sm-6">
						<span>Telefone</span>
						<input
							:disabled="disabled"
							v-model="rp.telefone"
							type="text"
							v-mask="'(##) ####-####'"
							placeholder="(__) ____-____"
							class="form-control"
						/>
					</div>
					<div class="col-sm-6 col-md-8">
						<span>Endereço</span>
						<input
							:disabled="disabled"
							v-model="rp.endereco"
							type="text"
							class="form-control"
						/>
					</div>

					<div class="col-md-4 col-sm-6">
						<span>PIS</span>
						<input
							:disabled="disabled"
							v-model="rp.pis"
							type="text"
							class="form-control"
						/>
					</div>

					<div class="col-sm-3">
						<span>Estado civil</span>
						<input
							:disabled="disabled"
							v-model="rp.estado_civil"
							type="text"
							class="form-control"
						/>
					</div>

					<div class="col-sm-3">
						<span>Naturalidade</span>
						<input
							:disabled="disabled"
							v-model="rp.naturalidade"
							type="text"
							class="form-control"
						/>
					</div>
				</div>
			</div>
		</div>
		<div class="col-xs-12" v-if="data.representates.length == 0">
			<br />
			<div class="alert alert-info">
				Você ainda tem Representantes cadastrados.
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Representante',
		props: ['dIn', 'disabled'],
		computed: {
			data() {
				return this.dIn;
			},
		},
	};
</script>
<style scoped>
	.close-item {
		display: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/customers/components/represent_legal.vue